export const getTextParts = (text: string, gapMark: string) => {
  if (!text) return [""];
  const parts = text.split(gapMark);
  return parts;
};
